import React, { useState } from "react";
import { withTranslation, Trans } from "react-i18next";
import Business from "./business";
import Indivisual from "./indivisual";
import SwipeableViews from 'react-swipeable-views';
import { connect } from "react-redux";
import ClientAppsDownloadBadge from "../../clientAppsDownloadBadge";
import {LoginRegisterTitle} from "../components/tabTitle";
import loadDynamicScript from "../../../../helper/module/loadDynamicScript";
import axios from "axios";
import { Helmet } from "react-helmet";

class App extends React.Component {
    constructor(props){
        super(props);
        this.state={
          activeTab : global.config.isIndividualTypeActive ?  0 : 1
        }
    }

    tabChange=(tab)=>{
        this.setState({
            activeTab : tab
        })
    }

    // componentDidMount(){
    //   loadDynamicScript(
    //     `https://www.google.com/recaptcha/enterprise.js?render=${global.config.grsk}`,
    //     "recaptchaEnterprise",
    //     async ()  => {
    //       window.grecaptcha.enterprise.ready(function () {
    //         window.grecaptcha.enterprise
    //           .execute(global.config.grsk, {
    //             action: "create_account"
    //           })
    //           .then(function (token) {
    //             console.log(token)

    //           })
    //           .catch(function (error) {
    //             console.log(error);
    //           });
    //       });
    //     }
    //   );
    // }


  render() {
    let axis= this.props.direction == "Ltr" ?"x" :"x-reverse" ;

    return <div className="loginRegisterContainer">
      <Helmet
    style={[{
        "cssText": `
        .App {
          overflow-y: scroll;                  
        }
        `
    }]}
/>
       {/* <Helmet>
           <style type="text/css">{`
            .App {
              overflow-y: scroll;                  
            }
         `}</style> 
        </Helmet> */}
        <div className="loginRegisterSwitchTab"> 
            {global.config.isIndividualTypeActive && <span style={{backgroundColor : this.state.activeTab == 0 ? global.config.colors.primaryUltraLight : "", width: !global.config.isBusinessTypeActive ? "100%" : ""  ,color :  this.state.activeTab == 0 ? global.config.colors.primaryOnLight :""}} onClick={()=>{this.tabChange(0)}} className={`PersonBusiness`} ><Trans i18nKey={"individual"}> </Trans></span>}
            {global.config.isBusinessTypeActive && <span style={{backgroundColor : this.state.activeTab == 1 ? global.config.colors.primaryUltraLight : "" , width: !global.config.isIndividualTypeActive ? "100%" : "",color :  this.state.activeTab == 1 ? global.config.colors.primaryOnLight : "" }} onClick={()=>{this.tabChange(1)}} className={`PersonBusiness`} ><Trans i18nKey={"Business"}> </Trans></span>}
         </div>   


          {(global.config.isIndividualTypeActive && this.state.activeTab == 0) && <Indivisual  LoginIsActive={this.props.LoginIsActive} activeTab={this.state.activeTab} />}
          {(global.config.isBusinessTypeActive && this.state.activeTab == 1) && <Business activeTab={this.state.activeTab} />}

        <ClientAppsDownloadBadge />

    </div>;
  }
}
const mapStateToProps = (state) => ({
    authenticated: state.SharedData.access_token,
    direction: state.SharedData.direction,
  });
  const mapDispatchToProps = (dispatch) => ({
    dispatch: dispatch,
  });
  
  export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(App));
  
  
  